<script>
import { Helper } from '@/mixin/helper'
import McGraphqlEditableTable from '@/components/McGraphqlEditableTable'
import {
  SERVICE_CATEGORIES,
  CREATE_SERVICE_CATEGORIES,
  UPDATE_SERVICE_CATEGORIES,
  DELETE_SERVICE_CATEGORIES,
} from '@/services/api/setting/maintenance/setting/categories'

export default {
  components: { McGraphqlEditableTable },
  mixins: [Helper],
  props: {
    status: String,
  },
  data() {
    return {
      data: [],
    }
  },
  computed: {
    fields() {
      return [
        {
          key: 'name',
          label: this.$t('maintenance.form.catService'),
          thClass: 'mc-table--50',
          isSortable: true,
          editable: true,
          validation: [['required'], ['isUnique', this.data]],
          orderBy: 'asc',
        },
      ]
    },

    buttons() {
      return [
        {
          variant: 'secondary',
          class: 'me-2',
          id: 'cat-service-log-button',
          text: this.$t('global.historyUpdate'),
          icon: 'icon-outline_file-text',
          handleClick: () => {
            this.handleClick()
          },
        },
      ]
    },

    query() {
      return {
        get: async (filter) => {
          const res = await this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: SERVICE_CATEGORIES,
            variables: {
              filter: filter,
            },
          })
          let self = this
          self.data = res.data.serviceCategories.serviceCategories.data

          const result = res.data.serviceCategories.serviceCategories
          result.data.forEach((item, index) => {
            if (item.companyId == 1) {
              result.data[index].disableCheckbox = true
              result.data[index].isShowEdit = false
            }
          })
          return result
        },
        store: async (data) => {
          const res = await this.$apollo.mutate({
            mutation: CREATE_SERVICE_CATEGORIES,
            variables: {
              input: {
                name: data.name,
              },
            },
          })

          return res.data.createServiceCategory.createServiceCategory
        },
        update: async (id, oldData, newData) => {
          const res = await this.$apollo.mutate({
            mutation: UPDATE_SERVICE_CATEGORIES,
            variables: {
              input: {
                oldData: {
                  name: oldData.name,
                },
                newData: {
                  name: newData.name,
                },
                serviceCategoryId: Number(id),
              },
            },
          })

          if (!res.data.updateServiceCategory.isSuccessful) {
            this.$mcToast.error({
              component: 'McToastDynamicBody',
              props: {
                contents: [
                  {
                    tag: 'h6',
                    text: this.$t('maintenance.alert.editFailed'),
                  },
                  {
                    tag: 'p',
                    text: this.$t(`global.alert.text.failedEdit`),
                  },
                ],
              },
            })
            return false
          }

          return res.data.updateServiceCategory.updateServiceCategory
        },
        delete: async (id) => {
          const res = await this.$apollo.mutate({
            mutation: DELETE_SERVICE_CATEGORIES,
            variables: {
              input: {
                serviceCategoryId: Number(id),
              },
            },
          })
          return res.data.deleteServiceCategory.isSuccessful
        },
      }
    },
  },

  mounted() {
    this.$store.commit('setting/SET_STATUS', this.status)
  },

  methods: {
    handleClick() {
      this.$router.push({ name: 'Log Maintenance Setting', params: { type: 'category' } })
    },

    customToast() {
      this.$mcToast.error({
        component: 'McToastDynamicBody',
        props: {
          contents: [
            {
              tag: 'h6',
              text: this.$t('maintenance.alert.deleteFailed'),
            },
            {
              tag: 'p',
              text: this.$t(`maintenance.errorMessages.CompServiceDelete`),
            },
          ],
        },
      })
    },
  },
}
</script>

<template>
  <!-- Rekrutmen -->
  <b-tab class="border-0 pb-4" @click="$store.commit('setting/SET_STATUS', status)">
    <template v-slot:title>
      <span class="d-sm-inline-block">{{ $t('maintenance.form.catService') }}</span>
    </template>

    <!-- Table -->
    <McGraphqlEditableTable
      :fields="fields"
      :buttons="buttons"
      :apiClient="query"
      trackBy="serviceCategoryId"
      :searchable="true"
      :isPredefined="true"
      :customToast="customToast"
    />
  </b-tab>
</template>
